import {
  buildSection,
  DetailTable,
  formatCurrency,
  humanizeEnum,
  yesNo,
  type DetailSection,
} from "./detailPrimitives";

// fsa_health / fsa_dependent_care — renders the employee's elected annual
// amount plus the plan's fsa_plan_config (when present). The election always
// exists for an FSA enrollment, so this block never shows the empty state.
export function FsaBenefitBlock({
  config,
  annualElection,
}: {
  config: any;
  annualElection?: number | null;
}) {
  const electionRows = [
    {
      label: "Annual Election",
      value: annualElection != null ? formatCurrency(annualElection) : "—",
    },
  ];
  if (config) {
    electionRows.push(
      { label: "Minimum", value: formatCurrency(config.annualElectionMin) },
      { label: "Maximum", value: formatCurrency(config.annualElectionMax) },
      { label: "Employer Contribution", value: formatCurrency(config.employerContribution) },
    );
  }

  const sections = [buildSection("Election", electionRows)];

  if (config) {
    sections.push(
      buildSection("Plan Rules", [
        { label: "Carryover Allowed", value: yesNo(config.carryoverAllowed) },
        {
          label: "Carryover Max",
          value: config.carryoverAllowed ? formatCurrency(config.carryoverMax) : "—",
        },
        {
          label: "Grace Period",
          value: config.gracePeriodDays ? `${config.gracePeriodDays} days` : "—",
        },
        {
          label: "Run-Out Period",
          value: config.runOutPeriodDays ? `${config.runOutPeriodDays} days` : "—",
        },
        { label: "Proration", value: humanizeEnum(config.prorationMethod) },
        { label: "Mid-Year Changes", value: yesNo(config.midYearChangeAllowed) },
      ]),
    );
  }

  return <DetailTable sections={sections.filter(Boolean) as DetailSection[]} />;
}
